const UUIDs = {
  REGISTRIERUNG: "8911fd96-3274-4015-80d6-fe0b5091bdef",
  PROFIL: "b7c87bce-bd77-45e4-97f6-fbdc16c6a9de",
};

export default UUIDs;
